'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _uiSvg = require('@spp/ui-svg');

var _uiInternalLink = require('@spp/ui-internal-link');

var _uiInternalLink2 = _interopRequireDefault(_uiInternalLink);

var _uiExternalLink = require('@spp/ui-external-link');

var _uiExternalLink2 = _interopRequireDefault(_uiExternalLink);

var _themeProvider = require('@spp/theme-provider');

var _irisPropTypes = require('@spp/iris-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthorHeaderSvgImage = (0, _themeProvider.themer)('@spp/ui-author-header:svg')(_uiSvg.SvgImage);

var facebookPrefix = '//www.facebook.com/';
var twitterPrefix = '//twitter.com/@';
var mailPrefix = 'mailto:';

var authorHeader = function authorHeader(name, id, authorUrlPrefix, theme) {
    return _react2.default.createElement(
        'h2',
        { className: theme.authorHeading, 'data-test-tag': '@spp/ui-author-header:heading' },
        _react2.default.createElement(
            _uiInternalLink2.default,
            { className: theme.authorLink, link: '' + authorUrlPrefix + id, rel: 'author', target: '_blank', enableSinglePage: true },
            name
        )
    );
};

var contactLink = function contactLink(url, name, icon, label, theme, urlPrefix) {
    return _react2.default.createElement(
        _uiExternalLink2.default,
        { href: '' + urlPrefix + url, rel: 'author' },
        _react2.default.createElement(AuthorHeaderSvgImage, { icon: icon, title: label, className: theme.icon, ariaHidden: 'true' }),
        _react2.default.createElement(
            'span',
            { className: theme.contactLabel },
            label,
            _react2.default.createElement(
                'span',
                { className: theme.visuallyhidden },
                ': ',
                name
            )
        )
    );
};

var contactItemMarkup = function contactItemMarkup(url, name, icon, label, ListElement, theme) {
    var urlPrefix = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';

    if (ListElement) {
        return _react2.default.createElement(
            ListElement,
            { className: theme.contactItem },
            contactLink(url, name, icon, label, theme, urlPrefix)
        );
    }
    return contactLink(url, name, icon, label, theme, urlPrefix);
};

var contactsMarkup = function contactsMarkup(author, theme, emailLabel, facebookLabel, twitterLabel, facebookIcon, emailIcon, twitterIcon) {
    var contacts = author.contacts;
    var mailAddress = contacts.filter(function (item) {
        return item.type === 'email';
    })[0];
    var facebookAddress = contacts.filter(function (item) {
        return item.type === 'facebook';
    })[0];
    var twitterAddress = contacts.filter(function (item) {
        return item.type === 'twitter';
    })[0];

    var multipleLinks = contacts.length > 1;

    var ListWrapper = multipleLinks ? 'ul' : 'div';
    var ListElement = multipleLinks ? 'li' : false;

    return _react2.default.createElement(
        ListWrapper,
        { className: theme.contacts, 'data-test-tag': '@spp/ui-author-header:contact-list' },
        mailAddress && contactItemMarkup(mailAddress.value, author.title, emailIcon, emailLabel, ListElement, theme, mailPrefix),
        facebookAddress && contactItemMarkup(facebookAddress.value, author.title, facebookIcon, facebookLabel, ListElement, theme, facebookPrefix),
        twitterAddress && contactItemMarkup(twitterAddress.value, author.title, twitterIcon, twitterLabel, ListElement, theme, twitterPrefix)
    );
};

var AuthorHeader = function AuthorHeader(_ref) {
    var author = _ref.author,
        label = _ref.label,
        theme = _ref.theme,
        emailLabel = _ref.emailLabel,
        facebookLabel = _ref.facebookLabel,
        twitterLabel = _ref.twitterLabel,
        facebookIcon = _ref.facebookIcon,
        emailIcon = _ref.emailIcon,
        twitterIcon = _ref.twitterIcon,
        authorUrlPrefix = _ref.authorUrlPrefix;
    var imageAsset = author.imageAsset;

    var image = false;

    if (imageAsset) {
        image = imageAsset.urls.filter(function (_ref2) {
            var width = _ref2.width;
            return width >= 200;
        })[0];
    }

    return _react2.default.createElement(
        'div',
        { className: theme.root, 'data-test-tag': '@spp/ui-author-header' },
        _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(theme.innerWrapper, image && theme.withImage) },
            authorHeader(author.title, author.id, authorUrlPrefix, theme),
            label && _react2.default.createElement(
                'span',
                { className: theme.label },
                label
            ),
            contactsMarkup(author, theme, emailLabel, facebookLabel, twitterLabel, facebookIcon, emailIcon, twitterIcon)
        ),
        image && _react2.default.createElement('div', { className: theme.background, style: { backgroundImage: 'url(' + image.url + ')' } }),
        image && _react2.default.createElement('img', { src: image.url, alt: author.title, className: theme.image })
    );
};

AuthorHeader.propTypes = {
    author: _irisPropTypes.objects.originator.isRequired,
    authorUrlPrefix: _propTypes2.default.string,
    label: _propTypes2.default.string,
    theme: _propTypes2.default.shape({
        authorHeading: _propTypes2.default.string,
        authorLink: _propTypes2.default.string,
        background: _propTypes2.default.string,
        contactItem: _propTypes2.default.string,
        contactLabel: _propTypes2.default.string,
        contacts: _propTypes2.default.string,
        innerWrapper: _propTypes2.default.string,
        image: _propTypes2.default.string,
        label: _propTypes2.default.string,
        link: _propTypes2.default.string,
        root: _propTypes2.default.string,
        withImage: _propTypes2.default.string
    }),
    emailLabel: _propTypes2.default.string.isRequired,
    twitterLabel: _propTypes2.default.string.isRequired,
    facebookLabel: _propTypes2.default.string.isRequired,
    facebookIcon: _propTypes2.default.shape({
        shape: _propTypes2.default.node,
        label: _propTypes2.default.string,
        viewbox: _propTypes2.default.string
    }).isRequired,
    emailIcon: _propTypes2.default.shape({
        shape: _propTypes2.default.node,
        label: _propTypes2.default.string,
        viewbox: _propTypes2.default.string
    }).isRequired,
    twitterIcon: _propTypes2.default.shape({
        shape: _propTypes2.default.node,
        label: _propTypes2.default.string,
        viewbox: _propTypes2.default.string
    }).isRequired

};

AuthorHeader.defaultProps = {
    theme: {},
    emailLabel: 'E-mail',
    facebookLabel: 'Facebook',
    twitterLabel: 'Twitter',
    authorUrlPrefix: '',
    facebookIcon: _uiSvg.facebook,
    emailIcon: _uiSvg.email,
    twitterIcon: _uiSvg.twitter

};

exports.default = AuthorHeader;
//# sourceMappingURL=AuthorHeader.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-author-header/lib/cjs/AuthorHeader.js
 ** module id = 569
 ** module chunks = 1
 **/